// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"LocationHeader_productDetailHeader__pY2Sd","customIcon":"LocationHeader_customIcon__iEtGd","customBackIcon":"LocationHeader_customBackIcon__YZNVo"};